import { makeStyles } from '@fluentui/react-components';

export const useTableStyles = makeStyles({
  value: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

